import buildTimeline from '../timelineBuilder';

export default function Timeline({ listing }) {
    const events = buildTimeline(listing);
    if (!events.length) return null;

    return (
        <div className="host-panel-section">
            <div className="host-panel-section-label">Status timeline</div>
            <div className="host-timeline">
                {events.map((event) => (
                    <div key={`${event.title}-${event.meta}`} className={`host-timeline-item ${event.state}`}>
                        <div className="host-timeline-title">{event.title}</div>
                        {event.meta && <div className="host-timeline-meta">{event.meta}</div>}
                        {event.body && <div className="host-timeline-body">{event.body}</div>}
                    </div>
                ))}
            </div>
        </div>
    );
}
